import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import { InputWrapperStyleProps } from "@/components/global/form/inputs/styles";
import {
  RadioInputStyleProps,
  defaultRadioInputStyles,
  radioInputStylesMap,
} from "@/components/global/form/inputs/styles/radio-input.styles";

interface RadioFieldProps {
  label?: string;
  className?: string;
  required?: boolean;
  dataCy?: string;
  defaultChecked?: boolean;
  defaultValue?: string;
  styles?: RadioInputStyleProps;
  wrapperStyles?: InputWrapperStyleProps;
  [key: string]: any;
}

export const RadioField = forwardRef<HTMLInputElement, RadioFieldProps>(
  (
    {
      label,
      className,
      dataCy,
      defaultChecked,
      styles,
      wrapperStyles: _wrapperStyles,
      defaultValue,
      ...props
    }: RadioFieldProps,
    ref,
  ) => {
    const mergedStyles = { ...defaultRadioInputStyles, ...styles };

    // Détermine si le composant est contrôlé ou non contrôlé
    const isControlled = "checked" in props || "value" in props;

    // Ne passe les props par défaut que si le composant est non contrôlé
    const defaultProps = isControlled
      ? {}
      : {
          ...(defaultChecked !== undefined && { defaultChecked }),
          ...(defaultValue !== undefined && { defaultValue }),
        };

    return (
      <div className="flex gap-2 mt-1 items-center justify-start">
        <input
          ref={ref}
          type="radio"
          id={label}
          data-cy={dataCy}
          {...defaultProps}
          className={twMerge(
            "bg-transparent cursor-pointer appearance-none rounded-full bg-white ring-2 flex items-center transition-all justify-center",
            "before:scale-0 checked:before:scale-[60%] before:rounded-full before:relative",
            radioInputStylesMap.size[mergedStyles.size],
            radioInputStylesMap.ringColor[mergedStyles.ringColor],
            radioInputStylesMap.checkedColor[mergedStyles.checkedColor],
            className,
          )}
          {...props}
        />
        <label className="cursor-pointer" htmlFor={label}>
          {label}
        </label>
      </div>
    );
  },
);

RadioField.displayName = "RadioField";
